import { render, staticRenderFns } from "./ElegibilidadeRenovabio.vue?vue&type=template&id=21153e3e&lang=pug"
import script from "./ElegibilidadeRenovabio.vue?vue&type=script&lang=js"
export * from "./ElegibilidadeRenovabio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports